import { loadable } from '@wix/communities-forum-client-commons/dist/src/services/loadable';

export default loadable(() => import(/* webpackChunkName: "badge-lib" */ '../badge'));
